import { CardNavigationPanel } from 'components/CardNavigationPanel';
import { DisplayJobCount } from 'components/DisplayJobCount';
import { FC } from 'react';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { MetaDataSelector } from '@doda/pc/src/redux/features/jobList';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import styles from './index.module.scss';

/**
 * 求人件数・ナビゲーションパネル
 */
export const ListControls: FC = () => {
  const jobListMeta = useAppSelector(MetaDataSelector);
  const totalCount = jobListMeta?.totalCount ?? 0;
  const resultCount = jobListMeta?.resultCount ?? 0;
  const offset = jobListMeta?.offset ?? 0;
  const limit = jobListMeta?.limit ?? 50;
  // 次のページが存在するかどうか
  const existNextPage = offset + limit < totalCount;
  const loginStatus = useAppSelector(loginStatusSelector);

  return (
    <div className={styles.listControl__wrapper}>
      <DisplayJobCount
        totalCount={totalCount}
        resultCount={resultCount}
        offset={offset}
      />
      <CardNavigationPanel
        hasNextPage={existNextPage}
        isPrsrt
        picAdditionalParam={{
          usrclk_searchList: `PC-${loginStatus ? 'login' : 'logout'}JobSearchList_searchResultHeaderArea_showImageConditions_image`,
        }}
        noPicAdditionalParam={{
          usrclk_searchList: `PC-${loginStatus ? 'login' : 'logout'}JobSearchList_searchResultHeaderArea_showImageConditions_noImage`,
        }}
        orderAdditionalParam={{
          usrclk_searchList: `PC-${loginStatus ? 'login' : 'logout'}JobSearchList_searchResultHeaderArea_sortConditions`,
        }}
      />
    </div>
  );
};
